<template>
  <div class="assets-type">
    <h3 v-show="buildAssets.length !== 0">
      {{ title }}
    </h3>
    <div class="assets-items">
      <div
        v-for="(item, index) in buildAssets"
        :key="`${index}-${item.src}`"
        class="assets-item"
        :class="{
          plus: item.added === false,
          minus: item.added === true,
          view: item.type === 'view',
        }"
        @click="handlerAsset(item)"
      >
        <AssetsImage :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import AssetsImage from "@/widgets/common/AssetsImage";
import { mapState } from "vuex";
import itemErrors from "@/store/observable/item-errors";

export default {
  name: "AssetsItemVue",
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    buildAssets: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["viewSMVMode"]),
    itemErrors,
  },
  components: {
    AssetsImage,
  },
  methods: {
    handlerAsset(item) {
      // if (this.viewSMVMode) return;
      itemErrors.update(item.src, !item.added);
      item.added = !item.added;
      if (item.type === "panorama") this.$store.dispatch("panorama/setPanoramaStatus", item.added);
      this.$store.dispatch("addSMVItem", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.assets-title {
  font-size: 24px;
  font-weight: bold;
  color: #2f363f;
  margin-bottom: 20px;
}
.assets-type {
  width: 100%;
  h3 {
    color: #6c7683;
  }
}
.assets-items {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media only screen and (min-width: 480px) {
    max-width: 100%;
    justify-content: space-around;
  }
  @media only screen and (min-width: 992px) {
    max-width: 140px;
    min-width: 120px;
    justify-content: flex-start;
  }
}
.assets-item {
  cursor: pointer !important;
  max-width: 60px;
  width: 100%;
  flex: 0 0 60px;
  transition: box-shadow 0.5s ease;
  padding: 5px;
  position: relative;

  &.view {
    max-width: 120px;
    flex: 0 0 120px;

    img {
      height: auto;
    }
  }
  &.spin {
    img {
      object-fit: contain;
    }
  }
  &:hover {
    box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16), 0 4px 4px rgba(50, 123, 186, 0.08);
  }

  &.plus,
  &.minus {
    z-index: 1;
    &::before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 2;
      opacity: 0;
      translate: opacity 0.5s ease;
    }
    &::after {
      content: "";
      width: 16px;
      height: 16px;
      background-image: url(https://sirv.sirv.com/website/theme2/icon/plus-circle.svg);
      background-size: cover;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      opacity: 0;
      translate: opacity 0.5s ease;
    }
    &:hover {
      &::before,
      &::after {
        opacity: 1;
      }
    }
  }
  &.minus {
    &::before {
      opacity: 1;
      background-image: url(https://sirv.sirv.com/website/theme2/icon/check.svg);
      background-position: 90% 10%;
      background-repeat: no-repeat;
      background-size: 10px;
    }
    &::after {
      background-image: url(https://sirv.sirv.com/website/theme2/icon/minus-circle.svg);
    }
  }
}
</style>
